var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Rejected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rejected",
    clipPath: "url(#clip-Rejected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9893",
    "data-name": "Group 9893",
    transform: "translate(-621 -213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(622 214)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(0)",
    fill: "red"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Denied",
    d: "M72.262,82.629c-.359-.056-.728-.084-1.083-.163a8.721,8.721,0,0,1-4.9-2.921A8.576,8.576,0,0,1,64.3,71.883a8.71,8.71,0,0,1,5.123-6.327,8.533,8.533,0,0,1,5.161-.644,8.678,8.678,0,0,1,4.391,2.137,8.825,8.825,0,0,1,2.87,5.1,11.618,11.618,0,0,1,.107,2.352,7.048,7.048,0,0,1-.163,1.083,8.839,8.839,0,0,1-3.01,4.983,8.69,8.69,0,0,1-4.181,1.96A9.094,9.094,0,0,1,72.262,82.629Zm-6.033-8.907a6.788,6.788,0,0,0,.919,3.392.526.526,0,0,0,.887.126l8.52-8.52a.522.522,0,0,0-.121-.887,6.62,6.62,0,0,0-5.133-.7A6.792,6.792,0,0,0,66.229,73.721Zm13.625,0a6.841,6.841,0,0,0-.91-3.378.531.531,0,0,0-.919-.121L69.541,78.7a.526.526,0,0,0,.126.915,6.663,6.663,0,0,0,4.591.793A6.8,6.8,0,0,0,79.853,73.721Z",
    transform: "translate(-54.086 -54.77)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedActive);
export default __webpack_public_path__ + "static/media/Rejected_Active.1d8875bd8f9bc59a6d039729c37c6a44.svg";
export { ForwardRef as ReactComponent };